import Tree from "../../../../structure/tree";
import CommonRules from "../../../common/rules/common-rules";
import FlagFootballRules from "../../../flag-football/rules/list";
import FootballRules from "../list";
import CflRules from "../cfl-list";
import Ruleset from "../../enums/ruleset";

const PatGame = new Tree(FootballRules.General.IsPatGame, [
    new Tree(FootballRules.General.SetTimeOnPlay, []),
    new Tree(FootballRules.General.Drive.AddPlay, [
        new Tree(FootballRules.General.StartGame, [])
    ]),
    new Tree(FootballRules.General.Scoring.Pat.Try, []),
    new Tree(FootballRules.General.Scoring.Pat.Run, []),
    new Tree(FootballRules.General.Scoring.Pat.RunStats, []),
    new Tree(FootballRules.General.Scoring.Pat.PassStats, []),
    new Tree(FootballRules.General.Scoring.Pat.KickStats, []),

    new Tree(FootballRules.General.CollectStatsOnPat, [
        new Tree(FootballRules.General.Kicks.RecordStatsFakeRun, []),
        new Tree(FootballRules.General.Kicks.RecordStatsFakeRunTouchdown, []),
        new Tree(FootballRules.General.Kicks.RecordStatsFakePassAttempt, []),
        new Tree(CflRules.General.Kicks.RecordStatsFieldGoal, []),
        new Tree(FootballRules.General.Kicks.RecordStatsFieldGoalBlocked, []),
        new Tree(FootballRules.Offensive.Rush.RecordStats, []),
        new Tree(FootballRules.Offensive.SpikeStats, []),
        new Tree(FootballRules.Offensive.Pass.Attempt.RecordStats, []),
        new Tree(FootballRules.Offensive.Pass.Complete.RecordStatsReceiver, []),
        new Tree(FootballRules.Offensive.ContinuedStats, []),
        new Tree(FootballRules.Offensive.LateralStats, []),
        new Tree(FootballRules.Offensive.KneelDownStats, []),
        new Tree(
            FootballRules.Offensive.Pass.Complete.RecordStatsQuarterback,
            []
        ),
        new Tree(FootballRules.Offensive.Pass.Incomplete.RecordStats, []),
        new Tree(FootballRules.Offensive.Pass.Interception.RecordStats, []),
        new Tree(FootballRules.Offensive.Pass.Sacked.RecordStats, []),
        new Tree(FootballRules.Offensive.Fumble.RecordStats, []),
        new Tree(FootballRules.Offensive.Fumble.RecoveryStats, []),
        new Tree(FootballRules.SpecialTeams.Punt.RecordStatsPunter, []),
        new Tree(FootballRules.SpecialTeams.Punt.Return.RecordStats, []),
        new Tree(CflRules.SpecialTeams.Punt.Return.RecordStatsFg, []),
        new Tree(
            FootballRules.SpecialTeams.Punt.Return.PuntNoRecoveryReturnerStats,
            []
        ),
        new Tree(FootballRules.SpecialTeams.Punt.TouchBack.RecordStats, []),
        new Tree(FootballRules.SpecialTeams.Punt.Blocked.RecordStats, []),
        new Tree(FootballRules.General.Kicks.RecordStatsKickOffReturn, []),
        new Tree(FootballRules.Defensive.Tackle.RecordStats, []),
        new Tree(FootballRules.Defensive.OutOfBounds.RecordStats, []),
        new Tree(FootballRules.Defensive.Safety.RecordStats, [])
    ]),

    new Tree(FootballRules.General.Scoring.Pat.Pass, []),
    new Tree(FootballRules.General.Scoring.Pat.Complete, [
        new Tree(FootballRules.General.Scoring.Pat.CompleteStats, [])
    ]),
    new Tree(FootballRules.General.Scoring.Pat.TurnoverPointsAwarded, []),
    new Tree(FootballRules.General.Scoring.Pat.DefenseComplete, [
        new Tree(FootballRules.General.Scoring.Pat.DefenseCompleteStats, [])
    ]),
    new Tree(FootballRules.General.Scoring.Pat.Fail, []),
    new Tree(FootballRules.General.Penalty.Accepted, [
        new Tree(FootballRules.General.StartGame, []),
        new Tree(FootballRules.General.Penalty.AcceptedStats, [])
    ]),
    new Tree(FootballRules.General.PlayEnd.Default, [
        new Tree(FootballRules.General.Drive.CollectTime, []),
        new Tree(FootballRules.General.CollectStatsOnPat, [
            new Tree(CflRules.Miscellaneous.RecordStatsTeamLoss, [])
        ])
    ]),
    new Tree(FootballRules.General.ResetField, [
        new Tree(FootballRules.General.SecondHalfPossessionSwitch, []),
        new Tree(FootballRules.General.NextKickOff, [])
    ]),
    new Tree(FootballRules.General.FirstDown, []),
    new Tree(FootballRules.General.FlagFirstDown, [])
]);

const RegularGame = new Tree(FootballRules.General.IsRegularGame, [
    new Tree(FootballRules.General.Timeout, []),
    new Tree(FootballRules.General.UpdateContext, [
        new Tree(FootballRules.General.UpdateContextStats, [])
    ]),
    new Tree(FootballRules.General.SwapTeams, []),
    new Tree(FootballRules.General.SetTimeAndPeriod, []),
    new Tree(FootballRules.General.CoinToss, [
        new Tree(FootballRules.General.OvertimeOpensWithDrive, []),
        new Tree(FootballRules.General.OvertimeOpensWithKickoff, [
            new Tree(FootballRules.General.StartKickOff, [])
        ])
    ]),
    new Tree(FootballRules.General.GameStart, [
        new Tree(FootballRules.General.StartKickOff, [])
    ]),
    new Tree(FootballRules.General.StartPeriod, []),
    new Tree(FootballRules.General.Drive.Create, [
        new Tree(FootballRules.General.Scoring.Pat.FieldSetup, [
            new Tree(FootballRules.General.Drive.EndDrive, [])
        ])
    ]),
    new Tree(FootballRules.General.SetTimeOnPlay, []),
    new Tree(FootballRules.General.Drive.AddPlay, [
        new Tree(FootballRules.General.StartGame, [])
    ]),
    new Tree(FootballRules.General.KickOff, [
        new Tree(FootballRules.General.Kicks.RecordStatsKickOff, []),
        new Tree(FootballRules.General.Kicks.Onside, []),
        new Tree(FootballRules.General.Kicks.KickOffPenaltyAccepted, []),
        new Tree(FootballRules.General.Kicks.KickOffPenaltyDeclined, []),
        new Tree(FootballRules.General.Kicks.KickOffOutOfBounds, [])
    ]),
    new Tree(FootballRules.General.Kicks.Rouge, []),
    new Tree(FootballRules.General.Kicks.RecordStatsFakeRun, []),
    new Tree(FootballRules.General.Kicks.RecordStatsFakeRunTouchdown, []),
    new Tree(FootballRules.General.Kicks.FieldGoalFakeRunFieldChange, []),
    new Tree(FootballRules.General.Kicks.RecordStatsFakePassAttempt, []),
    new Tree(FootballRules.General.Kicks.FieldGoalBlockedRecovery, []),
    new Tree(FootballRules.General.Kicks.FieldGoalFumbleNoRecovery, []),
    new Tree(FootballRules.General.Kicks.FieldGoalGood, [
        new Tree(
            FootballRules.General.Kicks.FieldGoalGoodNotAffectedByPenalty,
            []
        )
    ]),
    new Tree(FootballRules.General.Kicks.FieldGoalMissed, []),
    new Tree(FootballRules.General.Kicks.FieldGoalOutOfBounds, []),
    new Tree(CflRules.General.Kicks.RecordStatsFieldGoal, []),
    new Tree(FootballRules.General.Kicks.RecordStatsFieldGoalBlocked, []),
    new Tree(FootballRules.Offensive.Rush.RecordStats, []),
    new Tree(FootballRules.Offensive.Rush.FieldChange, []),
    new Tree(FootballRules.Offensive.Pass.Pass, []),
    new Tree(FootballRules.Offensive.SpikeStats, []),
    new Tree(FootballRules.Offensive.Pass.Attempt.RecordStats, []),
    new Tree(FootballRules.Offensive.Pass.Complete.RecordStatsReceiver, []),
    new Tree(FootballRules.Offensive.Pass.Complete.FieldChange, []),
    new Tree(FootballRules.Offensive.ContinuedStats, []),
    new Tree(FootballRules.Offensive.Continued, []),
    new Tree(FootballRules.Offensive.LateralStats, []),
    new Tree(FootballRules.Offensive.Lateral, []),
    new Tree(FootballRules.Offensive.KneelDownStats, []),
    new Tree(FootballRules.Offensive.KneelDown, []),
    new Tree(FootballRules.Offensive.Pass.Complete.RecordStatsQuarterback, []),
    new Tree(FootballRules.Offensive.Pass.Incomplete.RecordStats, []),
    new Tree(FootballRules.Offensive.Pass.Interception.RecordStats, []),
    new Tree(FootballRules.Offensive.Pass.Interception.FieldChange, []),
    new Tree(FootballRules.Offensive.Pass.Sacked.RecordStats, []),
    new Tree(FootballRules.Offensive.Pass.Sacked.FieldChange, []),
    new Tree(FootballRules.Offensive.Fumble.RecordStats, []),
    new Tree(FootballRules.Offensive.Fumble.RecoveryStats, []),
    new Tree(FootballRules.Offensive.Fumble.Recovery, []),
    new Tree(FootballRules.SpecialTeams.Punt.RecordStatsPunter, []),
    new Tree(FootballRules.SpecialTeams.Punt.NoReturn.FieldChange, []),
    new Tree(FootballRules.SpecialTeams.Punt.Return.FieldChange, []),
    new Tree(FootballRules.SpecialTeams.Punt.Return.RecordStats, []),
    new Tree(CflRules.SpecialTeams.Punt.Return.RecordStatsFg, []),
    new Tree(
        FootballRules.SpecialTeams.Punt.Return.PuntNoRecoveryReturnerStats,
        []
    ),
    new Tree(FootballRules.SpecialTeams.Punt.TouchBack.RecordStats, []),
    new Tree(FootballRules.SpecialTeams.Punt.Blocked.RecordStats, []),
    new Tree(FootballRules.SpecialTeams.Punt.Blocked.Recovery, []),
    new Tree(FootballRules.General.FairCatch, [
        new Tree(FootballRules.General.FairCatchTouchback, [])
    ]),
    new Tree(FootballRules.General.TouchBack, []),
    new Tree(FootballRules.General.Returned, []),
    new Tree(FootballRules.General.Kicks.NoRecoveryKickReturn, []),
    new Tree(FootballRules.General.Kicks.RecordStatsKickOffReturn, []),
    new Tree(FootballRules.Defensive.Tackle.RecordStats, []),
    new Tree(FootballRules.Defensive.OutOfBounds.RecordStats, []),
    new Tree(FootballRules.Defensive.Safety.Punt, []),
    new Tree(FootballRules.Defensive.Safety.Complete, [
        new Tree(FootballRules.Defensive.Safety.RecordStats, [])
    ]),
    new Tree(FootballRules.General.Penalty.Accepted, [
        new Tree(FootballRules.General.StartGame, []),
        new Tree(FootballRules.General.Penalty.AcceptedStats, [])
    ]),
    new Tree(FootballRules.General.PlayEnd.Default, [
        new Tree(FootballRules.General.Scoring.Touchdown, [
            new Tree(FootballRules.Offensive.TouchdownStats, []),
            new Tree(
                FootballRules.Offensive.Pass.Complete.RecordStatsTouchdown,
                []
            ),
            new Tree(FootballRules.Offensive.Fumble.RecordStatsTouchdown, []),
            new Tree(
                FootballRules.Offensive.Pass.Interception.RecordStatsTouchdown,
                []
            ),
            new Tree(FootballRules.Offensive.Rush.RecordStatsTouchdown, []),
            new Tree(
                FootballRules.SpecialTeams.Punt.Return.RecordStatsTouchdown,
                []
            ),
            new Tree(FootballRules.Offensive.Rush.ContinueTouchdownStats, []),
            new Tree(FootballRules.General.Scoring.Pat.FieldSetup, [])
        ]),
        new Tree(FootballRules.General.Drive.CollectTime, []),
        new Tree(FootballRules.General.PlayEnd.Down, [
            new Tree(FlagFootballRules.General.AwardFirstDown, []),
            new Tree(FlagFootballRules.General.CountTouchdownsAsFirstDowns, [
                new Tree(FlagFootballRules.General.ChangeDownStats, [])
            ]),
            new Tree(FootballRules.General.ChangeDown, [
                new Tree(CflRules.General.TurnoverOnDownStats, [])
            ])
        ]),
        new Tree(FootballRules.General.Turnover, []),
        new Tree(FootballRules.General.Drive.EndDrive, []),
        new Tree(FootballRules.General.ScoreEndedPossession, [
            new Tree(FootballRules.General.OvertimePossessionSwitch, [])
        ]),
        new Tree(CflRules.Miscellaneous.RecordStatsTeamLoss, [])
    ]),
    new Tree(FootballRules.General.ResetField, [
        new Tree(FootballRules.General.SecondHalfPossessionSwitch, []),
        new Tree(FootballRules.General.NextKickOff, []),
        new Tree(FootballRules.General.SkipKickoff, [])
    ]),
    new Tree(FootballRules.General.Finalize, [
        new Tree(FootballRules.General.FirstDown, []),
        new Tree(FootballRules.General.FlagFirstDown, [])
    ])
]);

//Rules are processed depth first
const DefaultCflRules = {
    id: Ruleset.Cfl.code,
    name: Ruleset.Cfl.name,
    rules: new Tree(CommonRules.Root, [PatGame, RegularGame])
};

export default DefaultCflRules;
